import React from 'react';
import { motion } from 'framer-motion';
import useTranslation from '../hooks/useTranslation';
import './About.css';

const ABOUT_IMAGE =
  '/images/aboutus.webp';

const About = () => {
  const { t, isRTL } = useTranslation();

  return (
    <section id="about" className="about" aria-label={isRTL ? 'من نحن' : 'About Us'}>
      <div className="container">
        <div className="about__grid">
          {/* Image column */}
          <motion.div
            className="about__image-col"
            initial={{ opacity: 0, x: isRTL ? 60 : -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="about__img-wrapper">
              <img
                src={ABOUT_IMAGE}
                alt={t('about.imageAlt')}
                width="600"
                height="480"
                loading="lazy"
                className="about__img"
              />
              {/* Floating badge */}
              <div className={`about__badge${isRTL ? ' about__badge--rtl' : ''}`}>
                <span className="about__badge-number">{t('about.badge')}</span>
                <span className="about__badge-label">{t('about.badgeLabel')}</span>
              </div>
              {/* Decorative ring */}
              <div className="about__ring" aria-hidden="true" />
            </div>
          </motion.div>

          {/* Text column */}
          <motion.div
            className="about__text-col"
            //initial={{ opacity: 0, x: isRTL ? -60 : 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
          >
            <div className="about__label" aria-hidden="true">
              <span />
              <span>{isRTL ? 'تعرّف علينا' : 'Who We Are'}</span>
            </div>
            <h2 className="about__title">{t('about.title')}</h2>
            <p className="about__body">{t('about.body')}</p>
            <p className="about__body2">{t('about.body2')}</p>

            {/* Stats row */}
            <div className="about__stats">
              {[
                { n: '360°', label: isRTL ? 'تغطية إبداعية' : 'Creative Coverage' },
                { n: '5+', label: isRTL ? 'خدمات متكاملة' : 'Integrated Services' },
                { n: '∞', label: isRTL ? 'إمكانات لا محدودة' : 'Unlimited Potential' },
              ].map((s, i) => (
                <div key={i} className="about__stat">
                  <strong>{s.n}</strong>
                  <span>{s.label}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
